/**
 * Reine Hilfslogik für die Wert-Vorschau ("Vorauswahlliste") im Filter-Dialog.
 * Bewusst ohne Abhängigkeit zum @luzula/luzula-lib-Barrel gehalten, damit sie
 * unter Vitest isoliert testbar ist (der Barrel zieht Leaflet/GeoPackage rein).
 */

/**
 * Felder des `header`-Objekts, die die View `_design/application/index` als
 * `key[4]` mitliefert (siehe BohrpunktDocumentHandler.getDesignDocuments →
 * view_map_str). Nur Filter-Felder, deren Accessor ausschließlich auf diese
 * Felder (bzw. `type`, `workflow`, `extendedHeader.mesoklima`) zugreift, lassen
 * sich aus den schlanken View-Rows berechnen — ohne `include_docs` (= ohne jeden
 * vollständigen Bohrpunkt zu laden).
 */
export const LIGHT_HEADER_KEYS = new Set<string>([
	'nummer', 'koordinaten', 'forstamt', 'forstbetrieb', 'revier', 'adresse',
	'aufnahme', 'bodenform', 'humusform', 'vegetationsformengruppe',
	'substratFeuchte', 'bemerkungen', 'wasserstufe', 'wasserstufe2', 'projects'
]);

/**
 * Entscheidet anhand des Feld-Accessors, ob die Wert-Vorschau allein aus den
 * schlanken View-Rows berechenbar ist (schneller Pfad). Alles, was in
 * `extendedHeader.*` (außer mesoklima), in berechneten Strukturen
 * (`Horizontfolge`, `Substratfolge`, `bodenvegetation.*`) oder im STFG-Sonderfall
 * (leerer Accessor) liegt, braucht die vollständigen Dokumente (langsamer Pfad).
 */
export function isLightweightField(accessor: string | undefined): boolean {
	const acc = accessor || '';
	if (acc === 'type') return true;
	if (acc.startsWith('workflow')) return true;                 // workflow → key[9]
	if (acc.startsWith('extendedHeader.mesoklima')) return true; // → key[7]
	if (acc.startsWith('header.')) {
		return LIGHT_HEADER_KEYS.has(acc.split('.')[1]);
	}
	return false;
}
